import { useMemo } from 'react';
import { nativeRequest } from './nativeBridge';
import ProductCameraAssistant, { CameraProduct, CameraRegion, ProductScan } from './ProductCameraAssistant';

export default function NativeProductCameraAssistant({ active, scan, onChanged }: { active: boolean; scan?: ProductScan; onChanged: () => void }) {
  const actions = useMemo(() => ({
    current: () => nativeRequest<CameraProduct | null>('qr-current'),
    resolve: (code: string) => nativeRequest<CameraProduct>('qr-resolve', { code }),
    expose: (productSeq: number) => nativeRequest<CameraProduct>('qr-expose', { productSeq }),
    capture: (productSeq: number, region: CameraRegion) => nativeRequest('qr-capture', { productSeq, region }),
  }), []);
  return <ProductCameraAssistant active={active} scan={scan} actions={actions} onChanged={onChanged} />;
}
